import React from "react";
import "./footer.scss";

interface FooterProps {
  cancelButtonText: string;
  submitButtonText: React.ReactNode;
  onCancelClick: () => void;
  onSubmitClick: () => void;
  isDisabled?: boolean;
  isCancelDisabled?: boolean;
  children?: React.ReactNode;
}

export function Footer(props: FooterProps) {
  return (
    <>
      <div className="footer">
        {props.children && props.children} 
        <button
          className="footer-button-cancel"
          onClick={props.onCancelClick}
          disabled={props.isCancelDisabled}
        >
          {props.cancelButtonText}
        </button>
        <button
          className="footer-button-submit"
          onClick={props.onSubmitClick}
          disabled={props.isDisabled}
        >
          {props.submitButtonText}
        </button>
      </div>
    </>
  );
}
